import { computed, ref, watch } from 'vue';
import { useUserStore } from './useStores';
import { LoginProvider } from '@/enums/login';

export function useVerifyEmail() {
	const { loadInfo, userInfo, isLoggedIn } = useUserStore();

	const showBanner = ref(false);

	const isAuthenticatedWithEmail = computed(() => userInfo.value.loginProvider === LoginProvider.JUSTWATCH);
	const userCreationTime = computed(() => userInfo.value.creationTime);

	watch(
		isLoggedIn,
		async () => {
			await loadInfo();

			if (!isLoggedIn.value || userInfo.value.emailVerified) {
				showBanner.value = false;
			}

			if (
				isLoggedIn.value &&
				isAuthenticatedWithEmail.value &&
				!userInfo.value.emailVerified &&
				!showBanner.value
			) {
				showBanner.value = true;
			}
		},
		{ immediate: true }
	);

	return {
		showBanner,
		userCreationTime,
	};
}
